import { DOCUMENT } from "@angular/common";

/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  EDITOR: {
    LEFT_TEXT: 'Text links',
    RIGHT_TEXT: 'Text rechts',
    CONFIG_ERROR: 'Konfigurationsfehler',
    QUESTIONNAIRE_API_URL_UNSET: 'API URL zum Abrufen von Fragebogen-Vorlagen wurde nicht gefunden. Bitte konfigurieren:',
    ASK_RESUME_QUESTIONNAIRE: 'Es ist eine nicht abgeschlossene Sitzung vorhanden. Möchten sie den Fragebogen jetzt weiter bearbeiten?',
    ASK_CANCEL_EDITING: 'Sie haben ungespeicherte Änderungen. Möchten Sie die Bearbeitung wirklich abbrechen?',
    QUESTIONNAIRE_EDITOR: 'Editor',
    ENTER_TITLE: 'Titel eingeben...',
    ENTER_SUBJECT: 'Betreff eingeben...',
    QUESTIONNAIRE_TYPE: 'Typ',
    QUESTIONNAIRE: 'Fragebogen',
    INFORMATION_SHEET: 'Aufklärungsbogen',
    STATUS: 'Status',
    DRAFT: 'Entwurf',
    APPROVED: 'Freigegeben',
    REV: 'Rev.',
    FILTER_GROUPS: 'Fachgruppen',
    SAVE: 'Speichern',
    SHOW: 'Zeige',
    NO_CONTENT: 'Keine Inhalte',
    ALL_CONTENT: 'Alle Inhalte',
    ALL_IMAGES: 'Alle Bilder',
    ALL_VIDEOS: 'Alle Videos',
    ALL_AUDIO: 'Alle Audio',
    ALL_DESCRIPTIONS: 'Alle Beschreibungen',
    ALL_DEPENDENCIES: 'Alle Abhängigkeiten',
    ALL_VARIABLES: 'Alle Variablen',
    EXPAND_ELEMENTS: 'Elemente ausklappen',
    FOLD_ELEMENTS: 'Elemente einklappen',
    JUMP_TO_ELEMENT: 'Zu Element springen',
    ELEMENTS: 'Elemente',
    FULL_SCREEN: 'Vollbild',
    OPTIONS: 'Optionen',
    DESCRIPTION: 'Beschreibung',
    MAIL_TEXT: 'Mailtext',
    ENTER_MAIL_TEXT: 'Mailtext eingeben...',
    IMAGE: 'Bild',
    ADD_IMAGE: 'Bild einfügen',
    SCORING: 'Scoring',
    PDF_FORMS: 'PDF Vorlagen',
    PDF_FORMS_INTRO: 'Importierte ausfüllbare PDF-Formulare mit der Fragebogenvorlage verknüpfen.',
    PDF_FORMS_HELP: 'Verknüpfen sie im Reiter "</> PDF Mapping" oder bei der jeweiligen Frage Variablen/Inhalte des Fragebogens mit befüllbaren Formularfeldern des importierten PDF-Formulars.',
    EXTERN_VARIABLES: 'Externe Variablen',
    FORMULA_VARIABLES: 'Formeln',
    EXCEL: 'Export',
    FORMULA: 'Formel',
    PDF: 'PDF',
    GDT: 'GDT',
    FILL_OPTIONS: 'Ausfüllen',
    GENERATE_INTERNAL_PDF: 'Internes PDF erstellen',
    SKIP_UNSIGNED_PDF: 'Export nicht signierter Dokumente überspringen',
    PDF_PLAIN_CARDS: 'Fragen-Karten randlos darstellen (ohne Rahmen und Schatten)',
    PDF_FONT_SCALE: 'Schriftgröße',
    PDF_FONT_SCALE_DEFAULT: 'Standard',
    PDF_COMPACT_SPACING: 'Kompakte Abstände zwischen den Fragen',
    PDF_INLINE_CHOICES: 'Antworten im PDF in einer Zeile darstellen',
    FORCE_MANDATORY: "Beantwortung von Pflichtfragen erzwingen",
    SKIP_LIST: "Fragebogen Liste überspringen bei einzelnem Fragebogen",
    SKIP_SUBMIT_CONFIRMATION: "Bestätigungsdialog beim Abgeben des Fragebogens überspringen",
    ADD_QUESTIONNAIRE_TITLE_TO_GDT: "Fragebogen Titel in GDT Datei einfügen",
    ADD_SCORING_TO_GDT: 'Scoring Ergebnisse in GDT Datei einfügen',
    ADD_FORMULA_RESULTS_TO_GDT: 'Formel Ergebnisse in GDT Datei einfügen',
    SCORING_VARIABLE: 'Scoring Variable',
    ADD_SCORING_VARIABLE: 'Scoring Variable einfügen',
    ADD_EXTERN_VARIABLE: 'Externe Variable einfügen',
    ADD_FORMULA_VARIABLE: 'Formel Variable einfügen',
    SCORING_VALUE_FOR_THIS_ANSWER: 'Wert',
    ENTER_DESCRIPTION: 'Beschreibung eingeben...',
    ERROR_LOADING_QUESTIONNAIRE: 'Beim Laden des Fragebogens ist ein Fehler aufgetreten',
    SUCCESSFULLY_SAVED_QUESTIONNAIRE: 'Der Fragebogen wurde erfolgreich gespeichert',
    ERROR_SAVING_QUESTIONNAIRE: 'Beim Speichern des Fragebogens ist ein Fehler aufgetreten',
    PLEASE_INSERT_TITLE_TO_SAVE: 'Achtung: Bitte Fragebogen Titel eingeben, um zu speichern',
    PLEASE_INSERT_FILTER_GROUP_TO_SAVE: 'Achtung: Bitte Fachgruppe zuordnen, um zu speichern',
    QUESTION_DELETE_ELEMENT: 'Sind sie sicher, dass sie dieses Element entfernen möchten?',
    QUESTIONNAIRE_LIMIT_REACHED: 'Lizenz Limit erreicht. Es können keine weiteren Fragebögen angelegt werden.',
    QUESTIONNAIRE_NO_PERMISSION: 'Sie haben keine Berechtigung, diesen Fragebogen zu bearbeiten.',
    DYNAMIC: 'Dynamisch',
    STATIC: 'Statisch',
    DIAGRAMS: 'Diagramme',
    COPY_QUESTION: 'Frage kopieren',
    INFO_TEXT: 'Infotext',
    PAGE_BREAK: 'Seitenumbruch',
    INPUT: 'Eingabe',
    NUMBER: 'Zahl',
    DATE: 'Datum',
    FREE_TEXT: 'Freitext',
    TEXT_MULTILINE: 'Freitext Mehrzeilig',
    MULTI_VALUE: 'Multiwerte',
    CHOICE: 'Auswahl',
    SINGLE_CHOICE: 'Eine Antwort',
    MULTIPLE_CHOICE: 'Mehrere Antworten',
    QUESTION_MATRIX: 'Fragen-Matrix',
    MEDIA: 'Medien',
    TAKE_PICTURE: 'Bild aufnehmen / hochladen',
    DRAWING: 'Zeichnung',
    SIGNATURE: 'Unterschrift',
    TEMPLATES: 'Vorlagen',
    YES_NO: 'Ja/Nein',
    YES_NO_MISC: 'Ja/Nein/Sonstiges',
    MULTIPLE_CHOICE_MISC: 'Mehrere Antworten/Sonstiges',
    ADD_ELEMENT: 'Element hinzufügen',
    ERROR_READING_QUESTIONNAIRE_JSON: 'Fragebogen JSON konnte nicht gelesen werden. Fehler:',
    QUESTIONNAIRE_JSON: 'Fragebogen JSON',
    IMPORT: 'Import',
    EXPORT: 'Export',
    DEBUGGING: 'Debugging',
    UNPACKED_EXPORT: 'Unpacked Export',
    QUESTIONNAIRE_PREVIEW: 'Fragebogen Vorschau',
    QUESTION: 'Frage',
    VARIABLE: 'Variable',
    AND: 'UND',
    OR: 'ODER',
    GROUP: 'Gruppe',
    CONDITION: 'Bedingung',
    SHOW_THIS_QUESTION_IF: 'Diese Frage einblenden wenn:',
    ADD_CONDITION: 'Bedingung hinzufügen',
    BACKGROUND_COLOR: 'Hintergrundfarbe',
    PEN_COLOR: 'Stiftfarbe',
    HEIGHT: 'Höhe',
    BACKGROUND_IMAGE: 'Hintergrundbild',
    AUTO_UNLOCK: 'Automatisch entsperren',
    ERROR_TRANSFERRING_IMAGE: 'Beim Übertragen des Bildes ist ein Fehler aufgetreten!',
    EDIT: 'Bearbeiten',
    REMOVE: 'Entfernen',
    ADD_ANSWER: 'Antwort hinzufügen',
    ADD_ENTRY: 'Eintrag hinzufügen',
    DATE_YMD_HM_TEXT: 'Monat, Jahr und Tag + Zeit : DD.MM.YYYY HH:mm',
    DATE_YMD_TEXT: 'Monat, Jahr und Tag: DD.MM.YYYY',
    DATE_YM_TEXT: 'Monat und Jahr: MM.YYYY',
    DATE_Y_TEXT: 'Jahr: YYYY',
    ROWS: 'Zeilen',
    ROW: 'Zeile',
    COLUMNS: 'Spalten',
    COLUMN: 'Spalte',
    VARIABLES: 'Variablen',
    ALLOW_HTML: 'Formatierten Text bei Copy & Paste erlauben',
    INPUT_OPTIONS: 'Eingabeoptionen',
    VALIDATION: 'Validierung',
    ADD_ROW: 'Zeile hinzufügen',
    ADD_COLUMN: 'Spalte hinzufügen',
    ANSWERS_PER_ROW: 'Antworten pro Zeile',
    PREVIEW: 'Vorschau',
    MIN: 'Min',
    MAX: 'Max',
    STEPS: 'Schritte',
    SCALE: 'Skala',
    SCALE_START_LABEL: 'Start-Label',
    SCALE_END_LABEL: 'End-Label',
    UNIT: 'Einheit',
    UNIT_EXAMPLE: 'Bsp. Kg',
    DISPLAY_TYPE: 'Anzeigetyp',
    INPUT_FIELD: 'Eingabefeld',
    SLIDER: 'Slider',
    NUMBER_WHEEL: 'Zahlen-Auswahlrad',
    TYPE_OF_SIGNATURE: 'Art der Unterschrift',
    QUESTION_TYPE_HAS_NO_CONFIGURABLE_CONTENT: 'Dieser Fragetyp hat keinen konfigurierbaren Inhalt',
    CLOSE: 'Schließen',
    SCOPE: 'Gültigkeitsbereich',
    VARIABLE_NAME: 'Name der Variable',
    RETURN_VALUE: 'Rückgabewert',
    SAVE_VARIABLE: 'Variable speichern',
    RESET_VARIABLE: 'Variable zurücksetzen',
    DELETE_VARIABLE: 'Variable löschen',
    NO_VARIABLES_CONFIGURED: 'Es wurden keine Variablen konfiguriert.',
    INVALID_VAR_NAME_TEXT: 'Variablenname ungültig. Mind. 3 Zeichen. Nur [a-zA-Z0-9_] erlaubt. Darf nicht mit Zahl beginnen.',
    INVALID_NUMBER_TEXT: 'Eingabe ungültig. Nur Zahlen erlaubt.',
    DUPLICATE_VAR_NAME_TEXT: 'Variablenname wird bereits bei einer anderen Frage verwendet.',
    INVALID_EXPRESSION: 'Eingabe ungültig. Nur Variablen, Zahlen, Arithmetische Operatoren und Math Funktionen erlaubt.',
    INVALID_CIRCULAR_EXPRESSION: 'Eingabe ungültig. Formel Variablen können nicht in einer Formel verwendet werden.',
    FORMULA_SYNTAX_ERROR: 'Syntaxfehler in der Formel',
    FORMULA_UNKNOWN_VARIABLE: 'Variable existiert nicht',
    FORMULA_UNKNOWN_MATH_FUNCTION: 'Unbekannte Math Funktion',
    FORMULA_MISSING_CLOSING_PAREN: 'schließende Klammer fehlt',
    FORMULA_EXTRA_CLOSING_PAREN: 'schließende Klammer zu viel',
    FORMULA_AUTOFIX: 'Formel automatisch reparieren',
    FORMULA_AUTOFIX_DONE: 'Formel automatisch repariert',
    FORMULA_BROKEN_TOAST: 'Dieser Fragebogen enthält fehlerhafte Formeln',
    ACTIVE: 'Aktiv',
    MANDATORY: 'Pflicht',
    MARK: 'Markieren',
    HIDE_IN_PDF: 'In PDF nicht anzeigen',
    HIDE_IN_APP: 'Beim Ausfüllen nicht anzeigen',
    HIDE_IN_XLS: 'In Tabellen Export nicht anzeigen',
    UPLOAD: 'Upload',
    IMAGES: 'Bilder',
    VIDEOS: 'Videos',
    AUDIO: 'Audio',
    ADD_IMAGES: 'Bilder hinzufügen',
    ADD_VIDEOS: 'Videos hinzufügen',
    ADD_AUDIO: 'Audio hinzufügen',
    DEPENDENCIES: 'Abhängigkeiten',
    MODE: 'Modus',
    MODE_DEFAULT: 'Standard',
    MODE_EXTENDED: 'Erweitert',
    SOURCE: 'Quelle',
    TARGET: 'Ziel',
    TYPE_STRING: 'String',
    TYPE_NUMERIC: 'Numeric',
    TYPE_DATE: 'Date',
    REGULAR_EXPRESSION: 'Regulärer Ausdruck',
    ERROR: 'Fehler',
    HINT: 'Hinweis',
    MAIL: 'Mail',
    SEND_INTERNAL_PDF: 'Internes PDF senden',
    SEND_FILLED_PDF: 'Ausgefülltes PDF senden',
    USER: 'Benutzer',
    FILLER: 'Ausfüller',
    NET_DIAGRAM: 'Netzdiagramm',
    OMIT_PATIENT_DATA: 'Patientendaten auslassen',
    NUMBER_RANGE: 'Zahlenbereich',
    ENTRIES: 'Einträge',
    DISTRIBUTION: 'Verteilung',
    DATASET_TITLE: 'Datensatz Titel',

    BAR_CHART: 'Balkendiagramm',
    COLUMN_CHART: 'Säulendiagramm',
    LINE_CHART: 'Liniendiagramm',
    PIE_CHART: 'Kreisdiagramm',
    CHART_TITLE: 'Diagramm-Titel',
    CHART_WIDTH: 'Breite (%)',
    CHART_ALIGNMENT: 'Ausrichtung',
    CHART_ALIGNMENT_LEFT: 'Links',
    CHART_ALIGNMENT_CENTER: 'Zentral',
    CHART_ALIGNMENT_RIGHT: 'Rechts',
    X_AXIS_LABEL: 'Beschriftung X-Achse',
    Y_AXIS_LABEL: 'Beschriftung Y-Achse',
    ENTRY_LABEL: 'Benennung',
    ENTRY_COLOR: 'Farbe',
    ADD_LINE: 'Linie hinzufügen',
    LINE_TITLE: 'Linientitel',
    SORT_BY_VALUE: 'Nach Größe sortieren (Uhrzeigersinn)',

    IMAGE_DISPLAY_OPTIONS: 'Darstellung in Dokumentansicht und PDF',
    IMAGE_WIDTH_PERCENT: 'Breite in % der Seitenbreite',
    IMAGE_FULL_WIDTH: 'Auf Seitenbreite (max. Originalgröße)',

    SUCCESSFULLY_TRANSLATED: 'Die Übersetzung wurde erfolgreich abgeschlossen.',
    AUTOMATIC_QUESTIONNAIRE_TRANSLATION: 'Automatische Fragebogen Übersetzung',
    TRANSLATE_QUESTIONNAIRE: 'Fragebogen übersetzen',
    ERROR_AUTO_TRANSLATING: 'Beim automatischen Übersetzen ist ein Fehler aufgetreten',
    CHARS: 'Zeichen',

    RADIO_BUTTONS: 'Radio Buttons',
    DROPDOWN: 'Dropdown',

    DOCUMENT_SCAN: 'Dokument scannen',
    DOCUMENT_SCAN_MIN_PAGES: 'Mindestanzahl Seiten',
    DOCUMENT_SCAN_MAX_PAGES: 'Höchstanzahl Seiten',

    REPEATABLE: 'Wiederholbar',
    EMAIL: 'E-Mail',
    EMAIL_SENDING_TO: 'E-Mail-Versand an:',
    EMAIL_RECIPIENTS_FIXED: 'Feste E-Mail Adresse(n), mehrere kommagetrennt',
    EMAIL_SEND_TO_ASSIGNER: 'An zuweisenden Benutzer senden',
    EMAIL_SEND_TO_FILLER: 'An Ausfüller senden',
    EMAIL_WHAT_TO_SEND: 'Was soll gesendet werden?',
    EMAIL_ATTACH_FILLED_PDF: 'Ausgefülltes Fragebogen-PDF anhängen',
    EMAIL_ATTACH_REPORT_PDF: 'Bericht-PDF anhängen',
    EMAIL_ATTACH_FILLED_DOCX: 'Word-Dokument anhängen',
    EMAIL_ATTACH_REPORT_DOCX: 'Bericht Word-Dokument anhängen',
    EMAIL_INCLUDE_ASSET_LINKS: 'Links zu Dateien hinzufügen',
    EMAIL_RECIPIENTS_INVALID: 'Bitte gültige E-Mail-Adresse(n) angeben (kommagetrennt).',

    PAGE_VIEW: 'Seitenansicht',
    PAGE: 'Seite',
    PREVIOUS_PAGE: 'Vorherige Seite',
    NEXT_PAGE: 'Nächste Seite',
    ADD_PAGE: 'Neue Seite einfügen',
    PAGE_ADDED_SUCCESSFULLY: 'Die Seite wurde erfolgreich eingefügt.',
    COPY_PAGE: 'Seite kopieren',
    PAGE_COPIED_SUCCESSFULLY: 'Die Seite wurde erfolgreich kopiert.',
    DELETE_PAGE: 'Seite löschen',
    CONFIRM_DELETE_PAGE: 'Möchten Sie diese Seite wirklich löschen?',
    PAGE_DELETED_SUCCESSFULLY: 'Die Seite wurde erfolgreich gelöscht.',
    MOVE_TO_PAGE: 'Auf Seite verschieben',
    TARGET_PAGE: 'Zielseite',
    INSERT_POSITION: 'Einfügeposition',
    PAGE_START: 'Anfang der Seite',
    PAGE_END: 'Ende der Seite',
    JUMP_TO_PAGE: 'Zur Zielseite springen',
    CONFIRM_MOVE_ELEMENT: 'Element wirklich auf diese Seite verschieben?',
    ELEMENT_MOVED_SUCCESSFULLY: 'Das Element wurde erfolgreich verschoben.',
    WIDTH_PERCENT: 'Breite %',
    WIDTH_PERCENT_SUM_WARNING: 'Die Summe der Spaltenbreiten überschreitet 100%.',

    AI_ASSISTANT: 'KI-Assistent',
    AI_INTRO: 'Beschreiben Sie, welchen Fragebogen die KI erstellen soll. Sie erhalten zuerst einen Vorschlag, den Sie bestätigen oder anpassen können.',
    AI_PLACEHOLDER: 'Nachricht an den KI-Assistenten eingeben...',
    AI_SEND: 'Senden',
    AI_CONFIRM_PLAN: 'Plan bestätigen & erstellen',
    AI_CONFIRM_MESSAGE: 'Ja, bitte erstellen.',
    AI_PROPOSED_PLAN: 'Vorschlag',
    AI_WORKING: 'KI arbeitet...',
    AI_RESULT_READY: 'Der Fragebogen wurde generiert und kann in den Editor übernommen werden.',
    AI_APPLY: 'In Editor übernehmen',
    AI_APPLIED: 'Der generierte Fragebogen wurde in den Editor übernommen. Bitte prüfen und speichern.',
    AI_NEW_SESSION: 'Neue Unterhaltung',
    AI_SESSION_ERROR: 'Bei der KI-Anfrage ist ein Fehler aufgetreten',
    AI_TOOL_PROPOSE_PLAN: 'Erstelle Vorschlag',
    AI_TOOL_READ_SCHEMA_DOCS: 'Prüfe Fragebogen-Spezifikation',
    AI_TOOL_BASH: 'Führe Berechnung aus',
    AI_TOOL_WRITE: 'Generiere Fragebogen',
    AI_TOOL_EDIT: 'Überarbeite Fragebogen',
    AI_TOOL_ANALYZE: 'Analysiere Daten',
    AI_TOOL_VALIDATE: 'Validiere Fragebogen',
    AI_TOOL_SUBMIT: 'Stelle Fragebogen fertig',
    AI_TOOL_READ_DOCUMENT: 'Lese Dokument',
    AI_ATTACH: 'Datei anhängen (PDF oder Bild)',
    AI_ATTACHMENT_PROMPT: 'Bitte erstelle einen Fragebogen aus der angehängten Datei.',
    AI_FILE_UNSUPPORTED: 'Dieser Dateityp wird nicht unterstützt. Erlaubt sind PDF, PNG, JPG und WebP',
    AI_FILE_TOO_LARGE: 'Die Datei ist zu groß. Maximal 10 MB pro Datei',
    AI_TOO_MANY_FILES: 'Es können maximal 5 Dateien pro Nachricht angehängt werden.'
  }
};
